import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config';

export default function AboutPage({ isDarkMode, toggleDarkMode }) {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState({
    title: 'Hakkımızda',
    content: '<p>İçerik henüz girilmemiş.</p>'
  });

  useEffect(() => {
    let cancelled = false;

    const fetchAbout = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/api/policies/about`);
        const data = await res.json();
        if (!cancelled) {
          setPolicy({
            title: data.title || 'Hakkımızda',
            content: data.content || '<p>İçerik henüz girilmemiş.</p>'
          });
        }
      } catch (_) {
        if (!cancelled) {
          setPolicy({
            title: 'Hakkımızda',
            content: '<p>Hakkımızda metni yüklenirken bir hata oluştu.</p>'
          });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchAbout();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900 dark:bg-[#050608] dark:text-white">
      <Header isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />

      <main className="mx-auto min-h-[70vh] w-full max-w-4xl overflow-x-hidden px-6 pb-16 pt-28 md:pt-32">
        <p className="text-xs font-black uppercase tracking-[0.24em] text-primary">Bana Bir Tarif Ver</p>
        <h1 className="mt-3 text-3xl font-black tracking-tight text-slate-950 dark:text-white md:text-5xl">
          {policy.title || 'Hakkımızda'}
        </h1>

        <section className="mt-8 min-w-0 border-t border-slate-200 pt-8 dark:border-slate-800">
          {loading ? (
            <div className="py-16 text-center text-sm font-bold text-slate-500 dark:text-slate-400">
              Hakkımızda metni yükleniyor...
            </div>
          ) : (
            <div
              className="bbtv-rich-text prose prose-slate w-full max-w-full overflow-x-hidden dark:prose-invert prose-p:leading-7 prose-li:leading-7"
              dangerouslySetInnerHTML={{ __html: policy.content }}
            />
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
}
